import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=05d4cbf4"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=05d4cbf4&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d4cbf4')) {
      api.createRecord('05d4cbf4', component.options)
    } else {
      api.reload('05d4cbf4', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=05d4cbf4", function () {
      api.rerender('05d4cbf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Logo.vue"
export default component.exports